import { useEffect, useRef } from 'react';

const API = '/api/notifications';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64  = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw     = window.atob(base64);
  return Uint8Array.from([...raw].map(c => c.charCodeAt(0)));
}

export default function usePushNotifications({ user, userType, city }) {
  const asked = useRef(false);

  useEffect(() => {
    if (asked.current) return;
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;

    // Wait 8 seconds before asking — don't interrupt landing
    const timer = setTimeout(async () => {
      if (asked.current) return;
      asked.current = true;

      // Already denied — don't ask again
      if (Notification.permission === 'denied') return;

      try {
        // Register service worker
        const reg = await navigator.serviceWorker.register('/sw.js');
        await navigator.serviceWorker.ready;

        // Check if already subscribed
        const existing = await reg.pushManager.getSubscription();
        if (existing) return; // already subscribed

        // Ask permission
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') return;

        // Get VAPID key
        const keyRes = await fetch(`${API}/vapid-public-key`);
        if (!keyRes.ok) return;
        const { key } = await keyRes.json();
        if (!key) return;

        // Subscribe
        const subscription = await reg.pushManager.subscribe({
          userVisibleOnly:    true,
          applicationServerKey: urlBase64ToUint8Array(key),
        });

        // Send to server
        const token = localStorage.getItem('spaczo_token');
        const endpoint = user
          ? `${API}/subscribe`
          : `${API}/subscribe-anonymous`;

        const headers = { 'Content-Type': 'application/json' };
        if (token) headers['Authorization'] = `Bearer ${token}`;

        await fetch(endpoint, {
          method:  'POST',
          headers,
          body: JSON.stringify({ subscription, userType: userType || 'seeker', city }),
        });
      } catch {
        // Silently fail — push is optional
      }
    }, 8000);

    return () => clearTimeout(timer);
  }, [user, userType, city]); // eslint-disable-line
}
